import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { useAsyncDebounce } from 'react-table';
import { InputDecorators } from '@isyc-react/form/modules/base';
import { useTranslation } from 'react-i18next';
import { nstable } from "../../../../i18n/namespaces";
import 'regenerator-runtime';
import "./filter-global-search.style.scss";
export const FilterGlobalSearch = props => {
  const {
    instance
  } = props;
  const {
    setGlobalFilter,
    state
  } = instance;
  const {
    globalFilter
  } = state;
  const {
    t
  } = useTranslation(nstable.common);
  const [value, setValue] = React.useState(globalFilter);
  const onChange = useAsyncDebounce(value => {
    setGlobalFilter(value || undefined);
  }, 200);

  // const onChange = (value: any) => {
  //   setGlobalFilter(value || undefined)
  // }

  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center w-100"
  }, /*#__PURE__*/React.createElement(InputDecorators, {
    value: value || '',
    onChange: (s, e) => {
      setValue(e.target.value);
      onChange(e.target.value);
    },
    className: "table-global-filter-input",
    input: {
      placeholder: t('table.controls.filter.global.placeholder')
    },
    focusInputOnDecoratorsFocus: true,
    prefix: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center"
    }, /*#__PURE__*/React.createElement("i", {
      className: "mdi mdi-magnify me-2 text-primary font-size-18"
    })))
  }));
};